<template>
    <div class="wrapper">
        <!-- Sidebar  -->
        <sidebarMenu />
        <!-- Page Content  -->
        <div id="content" class="d-flex flex-column min-vh-100">
            <navBar />
            <div class="px-5 pt-5 pb-5 flex-grow-1 body-color">
                <router-view/>
            </div>
            <footer style="background-color: rgba(0, 0, 0, 0.10);">
                <!-- Copyright -->
                <div class="py-4" v-if="user.isAdmin !== 1" >
                    <div class="container text-center">
                        <p class="text-muted mb-0 py-2">{{sucursalSelected}} © 2022 </p>
                    </div>
                </div>
                <div class="py-4" v-else>
                    <div class="container text-center">
                        <p class="text-muted mb-0 py-2">Ferreteria Hoyostools © 2022 </p>
                    </div>
                </div>
            </footer>
        </div>
        
    </div>
</template>

<script>
import sidebarMenu from './Sidebar'
import navBar from './Navbar'
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState('configuration', ['sucursalSelected']),
        ...mapState('auth', ['user']),
    },
    components:{
        sidebarMenu,
        navBar
    },
}
</script>

<style scope>
.theme--light.v-application {
    background: #e6e6e6;
}
.wrapper {
    display: flex;
    width: 100%;
    align-items: stretch;
}

.body-color {
    background-color: #f8f9fe;
}

#sidebar {
    min-width: 300px;
    max-width: 300px;
    transition: all 0.3s;
}

#sidebar.active {
    margin-left: -300px;
}

#sidebar .sidebar-header {
    padding: 20px;  
}
#content {
    width: 100%;
    min-height: 100vh;
    transition: all 0.3s;
    
}

body { 
    padding-right: 0 !important;
}
/* ---------------------------------------------------s
    MEDIAQUERIES
----------------------------------------------------- */

@media (max-width: 768px) {
    #sidebar {
        margin-left: -300px;
    }
    #sidebar.active {
        margin-left: 0;
    }
    #sidebarCollapse span {
        display: none;
    }
    #content {
        transition: all 0.3s;
        margin-right: -300px;
    }
}

@media print{
	#sidebar {
        margin-left: -300px;
    }
    .btn {
        display: none;
    }
}
</style>